import {SearchInput} from "./SearchDialog";
import {IconButtonWithLabel} from "../general/button/IconButtonWithLabel";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import {Badge, Box, Popover} from "@mui/material";
import PropTypes from "prop-types";
import {styled} from "@mui/styles";
import {useTranslation} from "react-i18next";

const StyledBadge = styled(Badge)(({theme}) => ({
    '& .MuiBadge-badge': {
        left: -5
    },
}));

PopoverSearchInput.propTypes = {
    value: PropTypes.string,
    onSubmit: PropTypes.func,
    p: PropTypes.number,
    m: PropTypes.number
}

PopoverSearchInput.defaultProps = {
    value: "",
    onSubmit: () => null,
}

export default function PopoverSearchInput({value, onSubmit, p, m, ...other}) {
    const {t} = useTranslation('common');
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        if (value)
            onSubmit();
    };

    const handleKeyDown = (event) => {
        if (event.keyCode === 13)
            handleClose();
    }

    const open = Boolean(anchorEl);
    const id = open ? 'search-input-popover' : undefined;

    return (
        <Box p={p} m={m} onKeyDown={handleKeyDown}>
            <StyledBadge
                badgeContent={`${value.substr(0, 5)}${value.length > 5 ? "..." : ""}`}
                invisible={!value}
                color="primary"
                overlap="circular"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}>
                <IconButtonWithLabel
                    aria-describedby={id}
                    label={t("main.components.search.placeholder")}
                    onClick={handleClick}
                >
                    <SearchIcon fontSize="small"/>
                </IconButtonWithLabel>
            </StyledBadge>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <SearchInput onSubmit={onSubmit} value={value} {...other}/>
            </Popover>
        </Box>
    );
}